import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import styled from '@emotion/styled';
import Link from '@atlaskit/link';
import { fg } from '@atlaskit/platform-feature-flags';
import { Text } from '@atlaskit/primitives/compiled';
import SectionMessage from '@atlaskit/section-message';
import { ActionSubject } from '@atlassian/proforma-utils/analytics';
// eslint-disable-next-line @repo/internal/react/no-class-components
export var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _callSuper(this, ErrorBoundary, [props]);
    _this.state = {
      hasError: false,
      errorInfo: null,
      error: null
    };
    return _this;
  }
  _inherits(ErrorBoundary, _React$Component);
  return _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      this.setState({
        hasError: true,
        error: error,
        errorInfo: errorInfo.componentStack
      });
      this.props.errorUtils.reportError(error, {
        actionSubject: ActionSubject.PROFORMA_UI,
        id: 'errorBoundary',
        errorInfo: errorInfo
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        // Render error UI here
        var renderError = this.props.renderError;
        return renderError ? renderError({
          error: this.state.error
        }) : /*#__PURE__*/React.createElement(ErrorPage, null, /*#__PURE__*/React.createElement(ErrorPageSection, null, /*#__PURE__*/React.createElement(SectionMessage, {
          appearance: "error",
          title: "Something went wrong"
        }, /*#__PURE__*/React.createElement(Text, {
          as: "p"
        }, "Refresh the page and try again. ", /*#__PURE__*/React.createElement("br", null), "If the error persists,", ' ', fg('dst-a11y__replace-anchor-with-link__jira-service-m') ? /*#__PURE__*/React.createElement(Link, {
          href: "https://support.thinktilt.com",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "contact support") :
        /*#__PURE__*/
        // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        React.createElement("a", {
          href: "https://support.thinktilt.com",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "contact support"), "."))));
      }
      return this.props.children;
    }
  }]);
}(React.Component);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var ErrorPage = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-empty-styled-expression -- Ignored via go/DSP-18766
var ErrorPageSection = styled.div({});